import { render, staticRenderFns } from "./SAvatar.vue?vue&type=template&id=261cd38d&scoped=true"
import script from "./SAvatar.ts?vue&type=script&lang=ts&external"
export * from "./SAvatar.ts?vue&type=script&lang=ts&external"
import style0 from "./SAvatar.scss?vue&type=style&index=0&id=261cd38d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261cd38d",
  null
  
)

export default component.exports